import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@cart/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CartVoucherApiService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
  ) {}

  private getCartVoucherEndpoint(cartId: string): string {
    return this.occEndpoints.buildUrl(API_ENDPOINTS.cartVoucher, {
      urlParams: { cartId },
    });
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  add(_userId: string, cartId: string, voucherId: string): Observable<unknown> {
    const url = this.getCartVoucherEndpoint(cartId);

    const toAdd = JSON.stringify({});

    const params: HttpParams = new HttpParams().set('voucherId', voucherId);

    const headers = this.getHeaders();

    const context: HttpContext = new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.cartVoucher);

    return this.http
      .post(url, toAdd, { headers, params, context })
      .pipe(catchError((error: any) => throwError(() => error)));
  }

  remove(_userId: string, cartId: string, voucherId: string): Observable<unknown> {
    const url = this.getCartVoucherEndpoint(cartId) + '/' + encodeURIComponent(voucherId);

    const context: HttpContext = new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.cartVoucher);

    const headers = this.getHeaders();

    return this.http.delete(url, { headers, context }).pipe(catchError((error: any) => throwError(() => error)));
  }
}
